// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606111041/js/" + chunkId + "." + {"44":"80156046","225":"1daf2fcb","481":"d943b61f","486":"9eb1bc46","770":"c5459306"}[chunkId] + ".0.9059559740593401.chunk.js";
};